import { Navigate, Outlet } from "react-router-dom";

const Protected = () => {
    const token = localStorage.getItem("token");
    return token  ? <Outlet /> : <Navigate to="/login" />;
};


export const PublicRoute = ({ children }) => {
    let tokenCheck = localStorage.getItem('token')
    return !tokenCheck ? children : <Navigate to='/' />
}


export default Protected;
